import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, MessageCircle } from "lucide-react";
import { Reveal, MaskLines, Magnetic, LiveDot } from "./ui/Primitives";

const HomeCTA: React.FC = () => {
  return (
    <section className="relative overflow-hidden bg-ink py-28 lg:py-40">
      {/* A single offset field of light, low and behind the type */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -bottom-40 left-1/2 h-[34rem] w-[52rem] -translate-x-1/2 rounded-full blur-[140px]"
        style={{
          background:
            "radial-gradient(ellipse, rgba(0,229,160,0.12) 0%, rgba(77,216,232,0.05) 50%, transparent 74%)",
        }}
      />

      <div className="shell relative z-10">
        <MaskLines
          as="h2"
          className="t-h1 max-w-[16ch] text-fg"
          lines={["מוכנים להפוך את הנוכחות", "הדיגיטלית שלכם למנוע צמיחה?"]}
        />

        <Reveal delay={120}>
          <p className="t-lead mt-8 max-w-[52ch]">
            השאירו פרטים ונחזור אליכם תוך שעות ספורות עם הצעה מותאמת אישית.
          </p>
        </Reveal>

        <Reveal delay={200}>
          <div className="mt-12 flex flex-col items-stretch gap-3 sm:flex-row sm:items-center">
            <Magnetic>
              <Link to="/contact" className="btn btn-primary group w-full px-9 py-4 text-base sm:w-auto">
                <span>דברו איתנו</span>
                <ArrowLeft className="h-4 w-4 transition-transform duration-300 ease-out-expo group-hover:-translate-x-1" />
              </Link>
            </Magnetic>
            <a
              href="https://wa.me/972557070007"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-ghost w-full px-9 py-4 text-base sm:w-auto"
            >
              <MessageCircle className="h-4 w-4" />
              <span>וואטסאפ</span>
            </a>
          </div>
        </Reveal>

        <Reveal delay={280}>
          <dl className="mt-16 grid gap-px border border-[var(--line)] bg-[var(--line)] sm:grid-cols-3">
            <div className="bg-ink p-6">
              <dt className="t-meta mb-2">טלפון</dt>
              <dd>
                <a
                  href="tel:+972557070007"
                  className="t-data text-lg text-fg transition-colors hover:text-signal"
                  dir="ltr"
                >
                  055-7070007
                </a>
              </dd>
            </div>
            <div className="bg-ink p-6">
              <dt className="t-meta mb-2">אימייל</dt>
              <dd>
                <a
                  href="mailto:info@eladkeren.com"
                  className="t-data text-lg text-fg transition-colors hover:text-signal"
                  dir="ltr"
                >
                  info@eladkeren.com
                </a>
              </dd>
            </div>
            <div className="bg-ink p-6">
              <dt className="t-meta mb-2">סטטוס</dt>
              <dd className="flex items-center gap-2.5 text-lg text-fg">
                <LiveDot />
                <span>זמינים עכשיו</span>
              </dd>
            </div>
          </dl>
        </Reveal>
      </div>
    </section>
  );
};

export default HomeCTA;
